module.exports = __webpack_public_path__ + "img/xieyiming.e7a54e68.png";